// import { useMemoize } from "@vueuse/core";
import { getSvgFromByteArray } from "./imageFunctions";

// const getSvgFromByteArrayMemoized = useMemoize(async (byteArray: Uint8Array, width?: number, height?: number): Promise<number> =>
//   getSvgFromByteArray(byteArray, width, height)
//     .catch(() => {
//       throw new Error(`Failed to get svg via byte array`);
//     }),
// );

export function convertSvg(bufferPtr: number, dataLength: number, width?: number, height?: number): Promise<number> {
  const svgByteArray = new Uint8Array(Module.HEAPU8.buffer, bufferPtr, dataLength);
  return getSvgFromByteArray(svgByteArray, width, height);
  // return getSvgFromByteArrayMemoized(svgByteArray, width, height);
}
